import React from 'react';
import ReactDOM from 'react-dom/client';

// Instrument Sans : la famille unique de la charte V3. Chargee localement plutot
// que depuis Google Fonts, ce qui vaut aussi pour l'animation de connexion, dont
// le JSON a ete degarni de ses `fPath`. Inter reste le temps que les ecrans prives
// passent a la V3 : les deux familles ne coexistent sur aucun ecran.
import '@fontsource-variable/instrument-sans';
import '@fontsource-variable/inter';

import App from './app/App';

import './index.scss';
import './login.scss';
import './tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
